const formater = new Intl.NumberFormat("en-US");
export class NumberFormater {
 static format(value: number) {
  return formater.format(value);
 }
 static roundUp(num: number, precision = 2) {
  return +num.toFixed(precision);
 }
}

export class MoneyFormater {
 static format(value: number) {
  if (value >= 1) return "$" + NumberFormater.format(value);
  return "$" + NumberFormater.roundUp(value, 4);
 }
}

export class BigIntFormater {
 static toNumber(value?: bigint) {
  if (value === undefined) return 0;
  return Number(value) / 1e18;
 }
 static format(value: bigint) {
  return formater.format(this.toNumber(value));
 }
 static roundUp(num: bigint, precision = 8) {
  return +this.toNumber(num).toFixed(precision);
 }
 static toDate(value?: bigint) {
  if (value == undefined) return undefined;
  if (Number(value) == 0) return undefined;
  return new Date(Number(value) * 1000);
 }
}

export class DateFormater {
 static format(date?: Date) {
  if (!date) return "";
  return date.toLocaleDateString("en-US", {
   year: "numeric",
   month: "numeric",
   day: "numeric",
  });
 }

 static formatDateTime(date?: Date) {
  if (!date) return "";
  return date.toLocaleString("en-US", {
   year: "numeric",
   month: "numeric",
   day: "numeric",
   hour: "numeric",
   minute: "numeric",
   hour12: false,
  });
 }
}
